/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 12:25:39
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import Card from '@/components/Common/Card';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'BillingSummary',

  props: ['billingList', 'isLoadingData', 'subscriber'],

  components: { Card },

  computed: {
    billingDateStart() {
      return `${this.billingList.terms.dateStart.slice(8, 10)}/${this.billingList.terms.dateStart.slice(5, 7)}/${this.billingList.terms.dateStart.slice(0, 4)}`;
    },
    billingDateEnd() {
      return `${this.billingList.terms.dateEnd.slice(8, 10)}/${this.billingList.terms.dateEnd.slice(5, 7)}/${this.billingList.terms.dateEnd.slice(0, 4)}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Billing/BillingSummary/component.js